import HttpService from "@/modules/core/network/http-service";

class ResidueSubtypeInventory extends HttpService {
  constructor() {
    super("stock/residue-subtype-inventory");
  }
}

export default new ResidueSubtypeInventory();
